// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"02025fde514c62c92551","655":"b7f2c4506024d0da2e04"}[chunkId] + ".js";
};